import {
    EpgProgram,
    MixedItem,
    RBLink,
    RBProgram,
    SearchProgram,
} from 'store/railsBuilder/reducer.types';

import { TECHNICAL_DEVICE_TYPE } from 'services/data-manager/constants';
import { BtvProgramme, VodEditorial } from 'services/data-manager/types';

export default function getDeeplinkItem(
    item:
        | VodEditorial
        | BtvProgramme
        | MixedItem
        | RBProgram
        | EpgProgram
        | SearchProgram
        | undefined,
): RBLink | undefined {
    if (!(item && item.links && item.links.length)) {
        return undefined;
    }

    return item.links.find(({ deviceType }) =>
        deviceType?.includes(TECHNICAL_DEVICE_TYPE),
    );
}
